import React from 'react'
import {change as changeFieldValue, Field, formValueSelector, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import $ from 'jquery';
import {
  minTamnhoIbge,
  renderField,
  renderFieldNumber,
  renderFieldSelect, renderFieldUpload,
  required,
  requiredSelect
} from '../../util/inputs';
import cadastrarCidade from '../../actions/cidade/cadastrarCidade';
import buscarCidades from '../../actions/cidade/buscarCidades';
import limparCidadeSelecionada from '../../actions/cidade/limparCidadeSelecionada';
import alterarCidade from '../../actions/cidade/alterarCidade';
import {estados} from '../../util/constantsUtil';
import {showSuccessMsg} from '../../util/messagesUtil';

export class ModalCadastrarCidade extends React.Component {
  constructor (props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.limparFormulario = this.limparFormulario.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  submit (values) {
    const cidade = {
      nome: values.nomeCidade,
      uf: values.estadoCidade.value,
      codigoIbge: values.codigoIbgeCidade,
      codigoAntt: values.codigoAnttCidade,
      id: this.props.cidade.id,
      base64Imagem: values.imagemCidade,
      urlImagem: values.urlImagem,
      imagem: values.imagem
    };
    if (this.props.cidade.id) {
      this.alterar(cidade)
    } else {
      this.cadastrar(cidade);
    }
  }

  cadastrar (cidade) {
    this.props.cadastrarCidade(cidade)
      .then(() => {
        showSuccessMsg('Cidade cadastrada com sucesso');
        this.fecharModal();
        this.props.buscarCidades(this.props.parametros, this.props.paginaAtual, this.props.registrosPorPagina);
      })
  }

  alterar (cidade) {
    this.props.alterarCidade(cidade)
      .then(() => {
        showSuccessMsg('Cidade alterada com sucesso');
        this.fecharModal();
        this.props.buscarCidades(this.props.parametros, this.props.paginaAtual, this.props.registrosPorPagina);
      })
  }

  limparMensagem () {
    this.setState({ mensagem: undefined })
  }


  limparFormulario () {
    this.props.reset('formularioCadastroCidade');
    this.props.limparCidadeSelecionada();
  }

  fecharModal () {
    $('#modalCadastrarCidade')
      .modal('hide');
    $('#modalCadastrarCidade')
      .hide();
    $('.modal-backdrop')
      .hide();
    this.limparFormulario();
  }
  
  removerImagem() {
    this.props.changeFieldValue('formularioCadastrarCidade',
      'imagemCidade', null);
    this.props.changeFieldValue('formularioCadastrarCidade',
      'urlImagem', null);
  }
  
  handleChange(event) {
    this.limparMensagem();
    const file = event.target.files[0];
    if (/\.(jpe?g|png|webp)$/i.test(file.name) === false) {
      const mensagem = {
        tipo: 'erro',
        texto: 'Formato de imagem inválido. Informe uma imagem nos formatos JPEG, PNG ou WebP.'
      };
      this.setState({mensagem});
      return
    }
    const imagem = file.name;
    this.setState({ imagem });
    this.converterParaBase64(file, imagem)
  }
  
  exibirImagem() {
    if (this.props.imagemCidade || this.props.urlImagem) {
      return (<div style={{marginLeft: 10}}>
        <img alt='' style={{width: '20%'}}
             src={this.props.imagemCidade ? this.props.imagemCidade : this.props.urlImagem}/>
        <button type="button" className="btn btn-editar mt-5"
                title='Remover'
                onClick={() => this.removerImagem()}>
          <i className="material-icons nav-icon" style={{
            fontSize: 18,
            color: 'red'
          }}>&#xe5cd;</i>
        </button>
      </div>)
    }
  }
  
  // eslint-disable-next-line class-methods-use-this
  converterParaBase64(file, imagem) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      this.props.changeFieldValue('formularioCadastrarCidade',
        'imagemCidade', reader.result);
      this.props.changeFieldValue('formularioCadastrarCidade',
          'imagem', imagem);
    }.bind(this);
    reader.onerror = function () {
      const mensagem = {
        tipo: 'erro',
        texto: 'Imagem inválida. Selecione outra imagem.'
      };
      this.setState({mensagem});
      this.removerImagem();
    }.bind(this);
  }

  render () {
    const {
      handleSubmit, submitting, invalid, pristine
    } = this.props;
    return (
      <div className="modal fade show" id='modalCadastrarCidade' role='dialog'
           aria-labelledby='modalCadastrarCidade' aria-hidden='true' data-backdrop='static'>
        <div className={'modal-dialog modal-dialog-centered modal-md'}>
          <div className="modal-content" style={{borderTop:'4px solid #FF6A00', borderRadius:12}}>
            <div className="modal-header" style={{borderBottom:'1px solid #f0f0f0'}}>
              <h5 style={{display:'flex', alignItems:'center', gap:8, margin:0, fontSize:16, fontWeight:700}}>
                <i className="material-icons" style={{color:'#FF6A00', fontSize:20}}>location_city</i>
                {this.props.cidade.id ? 'Alterar Cidade' : 'Cadastrar Cidade'}
              </h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                      onClick={this.limparFormulario}>
                <i className="material-icons">close</i>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit(this.submit)}>
                <div className="form-row mb-4">
                  <div className="col-12 col-sm-9 col-md-12">
                    <Field name='estadoCidade'
                           options={estados.map(elemento => ({
                             descricao: elemento.nome,
                             nome: elemento.uf
                           }))}
                           component={renderFieldSelect}
                           label='Estado:'
                           placeholder='Selecione o Estado' validate={requiredSelect}/>
                    <Field name="nomeCidade" type="text" component={renderField} validate={[required]} label="Nome:"
                           css="form-control" readOnly={false}/>
                    <Field name='codigoIbgeCidade' css="form-control" max={7} validate={[required, minTamnhoIbge]} component={renderFieldNumber} label="Código IBGE"/>
                    <Field name='codigoAnttCidade' css="form-control" max={6} component={renderFieldNumber} label="Código Antt"/>

                  </div>
                  <div className="form-group">
                    <div>
                      <label>Imagem cidade:</label>
                    </div>
                    <div className='input-wrapper'>
                      <Field name='imagemCidade'
                             component={renderFieldUpload}
                             handleChange={this.handleChange}
                             titulo={this.props.imagemCidade ? 'Alterar imagem' : 'Selecionar imagem'}/>
                    </div>
                  </div>
                  <div className="form-group">
                    {this.exibirImagem()}
                  </div>
                </div>
                <div className="modal-footer">
                  <button id="btn-salvar-cidade"
                          type="submit" disabled={invalid || submitting || pristine}
                          className="btn btn-laranja">Salvar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export function mapStateToProps (state) {
  return {
    cidades: state.cidades.cidades,
    paginaAtual: state.paginaAtualCidade,
    registrosPorPagina: state.registrosPorPaginaCidade,
    cidadeSelecionada: state.cidadeSelecionada,
    cidade: state.cidade,
    imagemCidade: formValueSelector('formularioCadastrarCidade')(state, 'imagemCidade'),
    urlImagem: formValueSelector('formularioCadastrarCidade')(state, 'urlImagem'),
    imagem: formValueSelector('formularioCadastrarCidade')(state, 'imagem'),
    initialValues: {
      nomeCidade: state.cidade.nome,
      codigoIbgeCidade: state.cidade.codigoIbge,
      codigoAnttCidade: state.cidade.codigoAntt,
      urlImagem: state.cidade.urlImagem,
      estadoCidade: {
        label: state.cidade.descricaoUf,
        value: state.cidade.uf
      }
    }
  }
}


export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    changeFieldValue,
    cadastrarCidade,
    buscarCidades,
    limparCidadeSelecionada,
    alterarCidade
  }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: 'formularioCadastrarCidade',
  enableReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(ModalCadastrarCidade));
